import React, { useEffect, useRef, useState } from 'react';

import { isEmpty } from 'lodash';

import { SINGLE_CHARACTER } from '../../constants';
import Input from '../input';

import './code-input.scss';

const NUMBER_STRING = '0123456789';

interface CodeInputProps {
  inputLength?: number;
  onInputFill(code: string): void;
  className?: string;
}

const CodeInput: React.FC<CodeInputProps> = ({
  onInputFill,
  inputLength = 5,
}) => {
  const [code, setCode] = useState<Record<string, string>>({});
  const refMap: Record<string, any> = {};
  Array(inputLength)
    .fill(0)
    .forEach((el, i) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const ref = useRef(null);
      refMap[i.toString()] = ref;
    });

  useEffect(() => {
    if (!isEmpty(refMap)) {
      refMap['0'].current && refMap['0'].current.focus();
    }
  }, []);

  useEffect(() => {
    const codeValue = Object.values(code).join('');
    if (codeValue.length === inputLength) {
      onInputFill(codeValue);
    }
  }, [code]);

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    i: number
  ) => {
    e.stopPropagation();
    const index = i.toString();

    if (NUMBER_STRING.includes(e.key) && !code[index]) {
      setCode({
        ...code,
        [index]: e.key,
      });

      if (i < inputLength - 1) {
        refMap[i + 1].current.focus();
      } else if (i === inputLength - 1) {
        refMap[i].current.blur();
      }
    } else if (e.key === 'Backspace') {
      setCode({
        ...code,
        [index]: '',
      });
    } else if (e.code !== 'Tab') {
      /* eslint-disable-next-line */
      return;
    }
  };

  return (
    <div className="code-input">
      {Array(inputLength)
        .fill(0)
        .map((el, i) => (
          <Input
            type={SINGLE_CHARACTER}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
              handleKeyDown(e, i)
            }
            value={code[i] ? code[i] : ''}
            ref={refMap[i]}
            key={`code-input-${i}`}
          />
        ))}
    </div>
  );
};

export default CodeInput;
